import React from "react";
import Layout from "../../components/layouts/Layout";

const About = () => {
  return (
    <>
      <Layout title={`About-us Ecommerceapp`}>
        <h4>About</h4>
      </Layout>
    </>
  );
};

export default About;
